module.exports = __webpack_public_path__ + "static/media/vinay.4918debe.jpg";